jQuery(($) => {
    const allTabs = $('body.ds .page-content .tabs').toArray();
    const switchTab = (tabs) => (event) => {
        if (event.target.classList.contains('active')) {
            return;
        }

        $('.leadership-drawers .profile.active', tabs).removeClass('active');
        $('.tab-pill.active', tabs).removeClass('active');
        event.target.classList.add('active');
        $('.tab-content.active, .tab-content[data-tab-index="' + event.target.dataset.tabIndex + '"]', tabs)
            .toggleClass('active');
    };

    for (const tabs of allTabs) {
        $('.tab-pill', tabs).on('click', switchTab(tabs));
    }

    const openLeaderDrawer = (profile, $allProfiles) => () => {
        if ($allProfiles.hasClass('active') && profile.classList.contains('active')) {
            return
        }
        $allProfiles.removeClass('active')
        profile.classList.add('active')
    }
    const closeLeaderDrawer = (profile) => () => profile.classList.remove('active')

    const $leadershipDrawerModules = $('body.ds .page-content .leadership-drawers').toArray()
    for (const leadershipDrawerModule of $leadershipDrawerModules) {
        const $allProfiles = $('.profile', leadershipDrawerModule);
        for (const profile of $allProfiles.toArray()) {
            profile.querySelector('.leader-card')
                .addEventListener('click', openLeaderDrawer(profile, $allProfiles))
            profile.querySelector('.close')
                .addEventListener('click', closeLeaderDrawer(profile))
        }
    }
});
